module.exports = __webpack_public_path__ + "img/SWIFT.0befa315.svg";